import { styled, keyframes } from '../theming';
import { StyledSvgContainerProps } from './types';

const loadingRotateKeyframe = keyframes`
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const loadingRotate2Keyframe = keyframes`
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(0deg);
  }
  66% {
    transform: rotate(360deg);
    opacity: 1;
  }
  67% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    transform: rotate(720deg);
  }
`;

const loadingDrawKeyframeFunc = (radius: number) => keyframes`
  0% {
    stroke-dashoffset: ${radius * 3.14 * 2};
  }
  50% {
    stroke-dashoffset: ${radius * 3.14 * 2 * 0.5};
  }
  100% {
    stroke-dashoffset: ${radius * 3.14 * 2};
  }
`;

const loadingDrawKeyframe2Func = (radius: number) => keyframes`
  0% {
    stroke-dashoffset: ${radius * 3.14 * 2};
  }
  25% {
    stroke-dashoffset: ${radius * 3.14 * 2 * 0.5};
  }
  66% {
    stroke-dashoffset: ${radius * 3.14 * 2};
  }
  100% {
    stroke-dashoffset: ${radius * 3.14 * 2};
  }
`;

export const StyledSvgContainer = styled.div<StyledSvgContainerProps>`
  svg {
    stroke-dasharray: ${({ radius }) => radius * 3.14 * 2};
    stroke-dashoffset: ${({ radius }) => radius * 3.14 * 2};
    fill: transparent;
    stroke: white;
    position: relative;
  }

  svg g {
    transform-origin: center;
  }

  svg g circle {
    transform-origin: center;
    transform: rotate(-92deg);
  }

  svg g.first {
    animation: ${loadingRotateKeyframe} 1.5s linear infinite;
  }
  svg g.first circle {
    stroke: ${(props) => props.color};
    animation: ${(props) => loadingDrawKeyframeFunc(props.radius)} 1.5s linear infinite;
  }

  svg g.second {
    animation: ${loadingRotate2Keyframe} 1.5s linear infinite;
  }
  svg g.second circle {
    stroke: ${(props) => props.color};
    opacity: 0.5;
    animation: ${(props) => loadingDrawKeyframe2Func(props.radius)} 1.5s linear infinite;
  }

  svg g.reduced {
    display: none;
  }

  @media (prefers-reduced-motion) {
    svg g.reduced {
      display: block;
    }
    svg g.first,
    svg g.second {
      display: none;
    }
    svg g circle {
      transform: none;
    }
  }
`;
